module.exports = __webpack_public_path__ + "img/head-logo.58f55c5c.png";